export const APPLICATION_STARTED = 'funnel.application_started';
export const APPLICATION_COMPLETE = 'funnel.application_complete';
export const APPLICATION_FUNDED = 'funnel.application_funded';
export const APPLICATION_TERMS_ACCEPTED = 'funnel.application_terms_accepted';
export const APPLICATION_TERMS_VIEWED = 'funnel.application_terms_viewed';
export const APPLICATION_SECURE_COMPLETE = 'funnel.application_secure';
export const APPLICATION_ADDRESS = 'funnel.application_address';
export const ACCOUNT_STEP_VIEW = 'app.account_signup_step_view';
export const ACCOUNT_STEP_COMPLETE = 'app.account_signup_step_complete';
